import Autoplay from 'embla-carousel-autoplay'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { useEmblaCarouselWithIndex } from '../../hooks/useEmblaCarouselWithIndex'
import Icon from '../icon'

interface ProvidersProps {
  children: ReactNode
  moreProviders: () => void
}

const ProvidersSlider = ({ children, moreProviders }: ProvidersProps) => {
  const { t } = useTranslation('casino')
  const { emblaRef, emblaApi } = useEmblaCarouselWithIndex(
    { loop: true, align: 'start' },
    [Autoplay()],
  )

  return (
    <div className="mt-1 mb-2 mx-auto px-1 py-0 xl:px-[84px] xl:py-0 3xl:px-36 3xl:py-0 4xl:px-[244px] 4xl:py-0">
      <div className="flex items-center justify-between mb-3 px-1 py-0 xl:px-1.5 xl:py-0">
        <button className="text-sm text-txt relative text-left font-normal leading-[21px] mt-1 xl:text-base">
          {t('game-providers')}
        </button>
        <div className="flex gap-2 [&>svg]:w-4 [&>svg]:h-4 [&>svg]:fill-[#0e091e]">
          <button
            className="flex items-center justify-center bg-secondary dark:bg-tertiary p-2 rounded hover:opacity-70 text-xs dark:text-txt"
            aria-label="Previous providers"
            onClick={moreProviders}>
            {t('more')}
          </button>
          <button
            className="flex items-center justify-center bg-secondary dark:bg-tertiary dark:fill-txt p-2 rounded hover:opacity-70"
            aria-label="Previous providers"
            onClick={() => emblaApi?.scrollPrev()}>
            <Icon id="chevron-left" width="16" height="16" />
          </button>
          <button
            className="flex items-center justify-center bg-secondary dark:bg-tertiary dark:fill-txt p-2 rounded hover:opacity-70"
            aria-label="Next providers"
            onClick={() => emblaApi?.scrollNext()}>
            <Icon id="chevron-right" width="16" height="16" />
          </button>
        </div>
      </div>
      <div className="embla" ref={emblaRef}>
        <div className="embla__container">{children}</div>
      </div>
    </div>
  )
}

export default ProvidersSlider
